<div class="callout">

<div class="document-titel-row">
    <a href="#" focus-me tabindex="0"  (click)="navigateToDetail()">{{detaildocument.PuntId ? '(a)' :'(z)'}} {{detaildocument.Titel}}</a>
</div>

<div class="document-zitting-row">
    <a href="#" tabindex="0" (click)="navigateToDetailZitting()">{{detaildocument.SoortZitting}} - {{detaildocument.DatumZitting | date:'dd.MM.y'}}</a>
</div>

</div>